"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CarouselNavButtonDirection = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));
var _KeyboardArrowRight = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowRight"));
var _clsx3 = _interopRequireDefault(require("clsx"));
var _theme = require("../_theme/theme");
var __jsx = _react.default.createElement;
var CarouselNavButtonDirection;
exports.CarouselNavButtonDirection = CarouselNavButtonDirection;
(function (CarouselNavButtonDirection) {
  CarouselNavButtonDirection[CarouselNavButtonDirection["Next"] = 0] = "Next";
  CarouselNavButtonDirection[CarouselNavButtonDirection["Previous"] = 1] = "Previous";
})(CarouselNavButtonDirection || (exports.CarouselNavButtonDirection = CarouselNavButtonDirection = {}));
var ArrowRight = function ArrowRight() {
  return __jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "37"
  }, __jsx("path", {
    d: "M0,0,16,14,32,0",
    transform: "translate(3 35) rotate(-90)",
    fill: "none",
    stroke: _theme.theme.palette.action.focus,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "4"
  }));
};
var ArrowLeft = function ArrowLeft() {
  return __jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "37"
  }, __jsx("path", {
    d: "M0,0,16,14,32,0",
    transform: "translate(17 2) rotate(90)",
    fill: "none",
    stroke: _theme.theme.palette.action.focus,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "4"
  }));
};
var directionToIconMap = function directionToIconMap(homepage) {
  var _ref;
  return _ref = {}, (0, _defineProperty2.default)(_ref, CarouselNavButtonDirection.Next, homepage ? ArrowRight : _KeyboardArrowRight.default), (0, _defineProperty2.default)(_ref, CarouselNavButtonDirection.Previous, homepage ? ArrowLeft : _KeyboardArrowLeft.default), _ref;
};
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    internalNavButton: {},
    navButton: {
      '&.Mui-disabled': {
        pointerEvents: 'auto'
      }
    },
    navButtonHomePage: {
      filter: 'drop-shadow(3px 0 0 white)'
    },
    previousNavButton: {
      left: '-30px',
      '&$internalNavButton': {
        left: '0px'
      }
    },
    nextNavButton: {
      right: '-30px',
      '&$internalNavButton': {
        right: '0px'
      }
    },
    navArrow: {
      fontSize: theme.typography.pxToRem(28),
      color: theme.palette.secondary.main,
      background: 'transparent',
      borderRadius: 0
    },
    navArrowRound: {
      background: theme.palette.background.default,
      opacity: 0.15,
      borderRadius: '50%',
      '&:hover': {
        opacity: '1'
      }
    },
    navArrowPagination: {
      fontSize: theme.typography.pxToRem(32),
      color: theme.palette.primary.main
    },
    navArrowDisabled: {
      color: theme.palette.text.disabled,
      opacity: 0.15,
      '&:hover': {
        opacity: 0.15
      }
    }
  };
});
var CarouselNavButton = function CarouselNavButton(_ref2) {
  var _clsx, _clsx2;
  var direction = _ref2.direction,
    isInsideContainer = _ref2.isInsideContainer,
    onClick = _ref2.onClick,
    isDisabled = _ref2.isDisabled,
    isPagination = _ref2.isPagination,
    isRound = _ref2.isRound,
    isHomepage = _ref2.isHomepage;
  var Icon = directionToIconMap(isHomepage)[direction];
  var classes = useStyles();
  var isNextButton = direction === CarouselNavButtonDirection.Next;
  var ariaLabel = isNextButton ? 'Next' : 'Previous';
  return __jsx(_core.ButtonBase, {
    className: (0, _clsx3.default)((_clsx = {}, (0, _defineProperty2.default)(_clsx, classes.navButton, true), (0, _defineProperty2.default)(_clsx, classes.navButtonHomePage, isHomepage), (0, _defineProperty2.default)(_clsx, classes.nextNavButton, isNextButton), (0, _defineProperty2.default)(_clsx, classes.previousNavButton, !isNextButton), (0, _defineProperty2.default)(_clsx, classes.internalNavButton, isInsideContainer), _clsx)),
    disabled: isDisabled,
    onClick: onClick,
    "aria-label": ariaLabel
  }, __jsx(Icon, {
    className: (0, _clsx3.default)((_clsx2 = {}, (0, _defineProperty2.default)(_clsx2, classes.navArrow, true), (0, _defineProperty2.default)(_clsx2, classes.navArrowDisabled, isDisabled), (0, _defineProperty2.default)(_clsx2, classes.navArrowRound, isRound), (0, _defineProperty2.default)(_clsx2, classes.navArrowPagination, isPagination === true), _clsx2))
  }));
};
var _default = CarouselNavButton;
exports.default = _default;